module.exports = __webpack_public_path__ + "img/about-4.c0e5d29f.png";